import { render, staticRenderFns } from "./MitManageBuildingPage.vue?vue&type=template&id=2d00eac4&scoped=true"
import script from "./MitManageBuildingPage.vue?vue&type=script&lang=js"
export * from "./MitManageBuildingPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageBuildingPage.vue?vue&type=style&index=0&id=2d00eac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00eac4",
  null
  
)

export default component.exports